<template>
  <v-dialog
    v-model="dialog"
    :fullscreen="$vuetify.breakpoint.mdAndDown ? true : false"
    :width="$vuetify.breakpoint.mdAndDown ? 'auto' : '500'"
    transition="dialog-bottom-transition"
    class="system-requirements"
    role="dialog"
    aria-modal="true"
    aria-labelledby="system-requirements-title"
  >
    <template #activator="{ on, attrs }">
      <v-btn
        aria-label="System Requirements"
        text
        class="system-requirements-button font-weight-medium text-body-2 ml-3 text-uppercase"
        v-bind="attrs"
        v-on="on"
        @click="dialogVisibility(true)"
      >
        {{ $t("components.menu.systemRequirements") }}
        <v-icon
          class="mb-2"
          small
        >
          fad fa-exclamation
        </v-icon>
      </v-btn>
    </template>

    <v-card>
      <v-toolbar color="secondary">
        <v-toolbar-title id="system-requirements-title">
          {{ $t("components.system.title") }}
        </v-toolbar-title>
        <v-spacer />
        <v-btn
          aria-label="Close dialog"
          icon
          @click="dialogVisibility(false)"
        >
          <v-icon>fal fa-times</v-icon>
        </v-btn>
      </v-toolbar>

      <v-alert
        type="info"
        role="status"
        aria-live="polite"
      >
        {{ $t("components.system.playableAt") }}
      </v-alert>

      <!-- Minimum Requirements -->
      <v-card-title class="system-requirements-title">
        {{ $t("components.system.minimumRequirements.title") }}
      </v-card-title>
      <v-list
        three-line
        subheader
      >
        <v-list-item
          v-for="section in ['os', 'cpu', 'memory', 'gpu', 'drive', 'softwares']"
          :key="section"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ $t(`components.system.minimumRequirements.${section}.title`) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t(`components.system.minimumRequirements.${section}.description`) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <!-- Recommended Requirements -->
      <v-card-title class="system-requirements-title">
        {{ $t("components.system.recommendedRequirements.title") }}
      </v-card-title>
      <v-list
        three-line
        subheader
      >
        <v-list-item
          v-for="section in ['os', 'cpu', 'memory', 'gpu', 'drive', 'softwares']"
          :key="section"
        >
          <v-list-item-content>
            <v-list-item-title>
              {{ $t(`components.system.recommendedRequirements.${section}.title`) }}
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ $t(`components.system.recommendedRequirements.${section}.description`) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
    data() {
        return {
            dialog: false
        };
    },
    methods: {
        dialogVisibility(visibility) {
            this.dialog = visibility;
        }
    }
};
</script>

<style lang="scss" scoped>
    .system-requirements {
        &-button {
            width: 100%;
        }

        &-title {
            flex-direction: column;
        }
    }
</style>
